
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CheckAgencyForExistingAccountRequest,
  CheckAgencyForExistingAccountResult,
} from '../models';
import {
    CheckAgencyForExistingAccountRequestFromJSON,
    CheckAgencyForExistingAccountRequestToJSON,
    CheckAgencyForExistingAccountResultFromJSON,
    CheckAgencyForExistingAccountResultToJSON,
} from '../models';

export interface CheckAgencyForExistingAccountOperationRequest {
    checkAgencyForExistingAccountRequest: CheckAgencyForExistingAccountRequest;
}

/**
 * 
 */
export class AgencyInfosApi extends runtime.BaseAPI {

    /**
     * Check for an existing agency
          */
    async checkAgencyForExistingAccountRaw(requestParameters: CheckAgencyForExistingAccountOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CheckAgencyForExistingAccountResult>> {
        if (requestParameters['checkAgencyForExistingAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'checkAgencyForExistingAccountRequest',
                'Required parameter "checkAgencyForExistingAccountRequest" was null or undefined when calling checkAgencyForExistingAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CheckAgencyForExistingAccountResult>({
            path: `/repatriation-opportunity/api/repatriation-opportunity-groups/subcontractor-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckAgencyForExistingAccountRequestToJSON(requestParameters['checkAgencyForExistingAccountRequest']),
        }, initOverrides);

        if (response._data) { response._data=CheckAgencyForExistingAccountResultFromJSON(response._data); }
        return response;
    }

    /**
     * Check for an existing agency
          */
    async checkAgencyForExistingAccount(requestParameters: CheckAgencyForExistingAccountOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CheckAgencyForExistingAccountResult> {
        const response = await this.checkAgencyForExistingAccountRaw(requestParameters, initOverrides);
        return response._data;
    }

}
